module.exports = __webpack_public_path__ + "static/media/sherritt-header-0004.17d57441.jpg";